import React from 'react';
import type DevopsConnectionsSettingsType from '@atlassian/jira-spa-apps-project-settings-devops-connections/src/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyDevOpsConnectionsSettings = lazyForPaint<typeof DevopsConnectionsSettingsType>(
	() =>
		import(
			/* webpackChunkName: "async-project-settings-devops-connections", jiraSpaEntry: "async-project-settings-devops-connections" */ '@atlassian/jira-spa-apps-project-settings-devops-connections'
		),
);

const AsyncDevOpsConnectionsSettings = (): React.JSX.Element => (
	<LazyPage
		Page={LazyDevOpsConnectionsSettings}
		pageId="devops-connections-settings"
		shouldShowSpinner={false}
	/>
);

export default AsyncDevOpsConnectionsSettings;
